/*******************************************************************************
  AddUserModal.js

  Author: Advait
*******************************************************************************/

import React, { useState } from "react";
import { useSelector } from "react-redux";
import { validateEmail, trimWhitespace } from "./helper/inputValidation";
import "../index.css";

function AddUserModal({ isOpen, onClose, onSubmit }) {
  const [role, setRole] = useState("tenant");
  const [selectedTenantId, setSelectedTenantId] = useState("");
  const [email, setEmail] = useState("");

  const tenantList = useSelector((state) => state.tenantList.tenants);

  const handleAdd = async () => {
    const trimmedEmail = trimWhitespace(email).toLowerCase();

    try {
      const response = await onSubmit(trimmedEmail, role, role === "tenant" ? selectedTenantId : null, false);

      console.log("User added successfully:", response);
      handleClose({ status: "success", data: response });
    } catch (err) {
      console.error("Error adding user:", err);

      const errorMessage = err.response?.data?.message || "Failed to add user";

      handleClose({ status: "error", message: errorMessage });
    }
  };

  const handleClose = (result = { status: "dismissed" }) => {
    setRole("tenant");
    setSelectedTenantId("");
    setEmail("");
    onClose(result);
  };

  const handleRoleChange = (newRole) => {
    setRole(newRole);
    if (newRole === "sysadmin") {
      setSelectedTenantId("");
    }
  };

  const isAddDisabled = () => {
    const trimmedEmail = trimWhitespace(email);
    if (!trimmedEmail || !validateEmail(trimmedEmail)) return true;
    if (role === "tenant" && !selectedTenantId) return true;
    return false;
  };

  if (!isOpen) return null;

  return (
    <div className="addUserOverlay" onClick={handleClose}>
      <div className="addUserContainer" onClick={(e) => e.stopPropagation()}>
        <button className="addUserCloseButton" onClick={handleClose}>
          ×
        </button>
        <h3>Add New User</h3>

        <div className="addUserFormGroup">
          <div className="addUserRadioGroup">
            <label>
              <input
                type="radio"
                name="role"
                value="tenant"
                checked={role === "tenant"}
                onChange={() => handleRoleChange("tenant")}
              />
              <span>Tenant</span>
            </label>
            <label>
              <input
                type="radio"
                name="role"
                value="sysadmin"
                checked={role === "sysadmin"}
                onChange={() => handleRoleChange("sysadmin")}
              />
              <span>Sysadmin</span>
            </label>
          </div>
        </div>

        {role === "tenant" && (
          <div className="addUserFormGroup">
            <h6>Select Tenant</h6>
            <select
              className="inputFieldSelect"
              value={selectedTenantId}
              onChange={(e) => setSelectedTenantId(e.target.value)}
            >
              <option value="">-- Please Choose a Tenant --</option>
              {tenantList.map((tenant) => (
                <option key={tenant.id} value={tenant.id}>
                  {tenant.company}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="addUserFormGroup">
          <h6>Email Address</h6>
          <input
            type="email"
            className="inputField"
            placeholder="user@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div
          className="addUserFormGroup"
          style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
        >
          <button className="saveButton" onClick={handleClose} style={{ minWidth: "100px" }}>
            Cancel
          </button>
          <button
            className="saveButton"
            onClick={handleAdd}
            disabled={isAddDisabled()}
            style={{ minWidth: "100px" }}
          >
            Add
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddUserModal;
